import { useEffect } from "react";
import { FormActions } from "../../components/common/FormActions";
import FormFields from "../../components/common/FormFields";
import { PARISH } from "../../utils/constants";
import {
  createColumn,
  createEditAction,
  getForm,
  getRegister,
} from "../../utils/helpers";
import { URL_PARISHES } from "../../utils/urls";
import useGet from "../common/useGet";
import { API_SUB_COUNTIES } from "../../utils/apis";

export const useParishes = () => {
  const tableColumns = () => [
    createColumn("name", true, "Parish"),
    createColumn("sub_county_name", true, "Sub County"),
    createColumn("actions", false, "Actions"),
  ];
  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        actions: (
          <FormActions actions={[createEditAction(URL_PARISHES, item?.id)]} />
        ),
      };
    }),
  ];

  const formRoute = getForm(URL_PARISHES);

  return { tableData, tableColumns, formRoute };
};

export const useParishesForm = () => {
  const { loadData, loading, data: subCountyData } = useGet();
  useEffect(() => loadData({ api: API_SUB_COUNTIES }), []);
  const fields: any = [
    {
      field_name: "parent",
      label: "Sub County",
      type: "select",
      props: { required: true },
      options_data: subCountyData?.results,
      loading,
    },
    {
      field_name: "name",
      label: "parish name",
      type: "text",
      props: { required: true },
    },
  ];
  const sections: any = [
    {
      title: "Parish details",
      fields,
    },
  ];

  const redirect = getRegister(URL_PARISHES);

  const defaultValues = { location_type: PARISH };

  return { fields, sections, redirect, defaultValues };
};

export const ParishesForm = ({
  form,
  error,
  updateFormValue,
  onChange,
}: any) => {
  const { fields } = useParishesForm();
  return (
    <FormFields
      fields={fields}
      error={error}
      form={form}
      updateFormValue={updateFormValue}
      onChange={onChange}
    />
  );
};
